<template>
  <div class="main-cn-index">
    <PC />
  </div>
</template>

<script lang="ts" setup>
import { measureWebVitals } from '~/utils/web-vitals';
import PC from './pc.vue';

onMounted(() => {
  // 仅在开发环境下启用性能监控
  if (process.env.NODE_ENV === 'development') {
    measureWebVitals();
  }
});
</script>
